import React from 'react'
import { Drawer, IconButton, Typography } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import CircleLoader from 'components/Loading/CircleLoader'
import CreateForm from './CreateForm'
import messages from '../translate'

function FreshwaterClientListForm({
  intl: { formatMessage },
  onPanelClose,
  isFormOpened,
  isSavingForm,
  siteType,
  selectedSnapshot,
}) {
  return (
    <Drawer
      className="info-panel projected-sites-manager-form"
      variant="persistent"
      anchor="right"
      open={isFormOpened}
      classes={{
        paper: 'info-panel-paper',
      }}>
      <CircleLoader loading={isSavingForm} />
      <div className="info-panel-header">
        <Typography className="info-title" variant="subtitle1">
          {formatMessage(messages.newRow)}
        </Typography>
        <div className="action-group">
          <IconButton size="small" onClick={onPanelClose}>
            <CloseIcon />
          </IconButton>
        </div>
      </div>
      <CreateForm
        onPanelClose={onPanelClose}
        siteType={siteType}
        selectedSnapshot={selectedSnapshot}
      />
    </Drawer>
  )
}

export default connect(state => ({
  isSavingForm: state.getIn(['projectedSitesManager', 'isSavingForm']),
}))(injectIntl(FreshwaterClientListForm))
